import { css } from 'styled-components';

const variables = css`
  :root {
    /* Warm charcoal + terracotta. The variable NAMES are inherited from the
       template and no longer describe the colors — --navy is a warm charcoal
       and --green is terracotta. Renaming them would touch 45+ call sites for
       no benefit, so the names stay and the values carry the palette.

       Contrast against --navy: accent 5.8:1, --slate 6.3:1,
       --light-slate 9.1:1. All clear WCAG AA for body text. */
    --dark-navy: #14100d;
    --navy: #1b1613;
    --light-navy: #251f1a;
    --lightest-navy: #3a322b;
    --navy-shadow: rgba(10, 8, 6, 0.7);
    --dark-slate: #6b6058;
    --slate: #a39689;
    --light-slate: #bdb1a5;
    --lightest-slate: #e8e0d6;
    --white: #f7f2ea;
    --green: #e2725b;
    --green-tint: rgba(226, 114, 91, 0.1);
    --pink: #f57dff;
    --blue: #57cbff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
